import { useAtom } from "jotai";
import React from "react";
import { clockModeThemeAtom, clockModeVisualConfigAtom, customBackgroundImageAtom } from "../../../../../atoms/v3/clockModeAtoms";
import { ClockModeThemeSettings } from "../themes/ClockModeThemeSettings";

const ClockModeBackground: React.FC = () => {
  const [theme] = useAtom(clockModeThemeAtom);
  const [themeConfig] = useAtom(clockModeVisualConfigAtom);
  const [customBackgroundImage] = useAtom(customBackgroundImageAtom);

  const themeSettings = React.useMemo(
    () => ClockModeThemeSettings.find((t) => t.id === theme),
    [theme]
  );

  const backgroundStyle = React.useMemo(() => {
    // 处理自定义图片主题
    if (theme === "custom-image") {
      if (customBackgroundImage) {
        return {
          backgroundImage: `url(${customBackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        };
      } else {
        // 没有自定义图片时显示占位符
        return {
          background: "linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%)",
          backgroundSize: "cover",
        };
      }
    }

    if (!themeSettings?.value) return undefined;
    // If value looks like a gradient or color, use as background
    // If value looks like a URL, use as backgroundImage
    if (themeSettings.value.startsWith("url(")) {
      return {
        backgroundImage: themeSettings.value,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      };
    }
    return {
      background: themeSettings.value,
      backgroundSize: "cover",
    };
  }, [themeSettings, theme, customBackgroundImage]);

  return (
    <div
      className={`absolute w-full h-full left-0 top-0 transition duration-300 bg-cover bg-center ${
        themeConfig?.useBackgroundBlur ? "blur-lg scale-110" : ""
      }`}
      style={backgroundStyle}
    />
  );
};

export default ClockModeBackground;
